import { AnyAction, Dispatch } from '@reduxjs/toolkit'
import { MainProjectVideoService, Video } from 'api/schema'
import { AllVideosActions } from 'store/actions/allVideos'
import { PROGRESS_TYPES } from 'utils/constants'
import { RootState } from 'utils/interfaces'

const fetchAllVideos = (projectId?: Array<number>) => {
  return async (dispatch: Dispatch<AnyAction>, getState: () => RootState) => {
    try {
      dispatch(AllVideosActions.setLoadingProgress(PROGRESS_TYPES.WORK))
      let allVideos: Video[] = []
      let page = 1
      let hasMore = true

      while (hasMore) {
        const allVideosRaw = await MainProjectVideoService.mainVideoList(undefined, undefined, page, 1000, projectId)
        allVideos = [...allVideos, ...(allVideosRaw.results || [])]
        hasMore = allVideosRaw.page_next !== null
        page++
      }

      dispatch(AllVideosActions.setAllVideos(allVideos))
      dispatch(AllVideosActions.setLoadingProgress(PROGRESS_TYPES.SUCCESS))
    } catch (error) {
      dispatch(AllVideosActions.setLoadingProgress(PROGRESS_TYPES.ERROR))
    }
  }
}

const fetchGroupVideos = (groupId?: Array<number | null>) => {
  return async (dispatch: Dispatch<AnyAction>, getState: () => RootState) => {
    try {
      dispatch(AllVideosActions.setLoadingProgress(PROGRESS_TYPES.WORK))
      const videosRaw = await MainProjectVideoService.mainVideoList(groupId, undefined, undefined, 2000, undefined)
      dispatch(AllVideosActions.setGroupVideos(videosRaw.results || []))
      dispatch(AllVideosActions.setLoadingProgress(PROGRESS_TYPES.SUCCESS))
    } catch (error) {
      dispatch(AllVideosActions.setLoadingProgress(PROGRESS_TYPES.ERROR))
    }
  }
}

export const allVideosThunks = {
  fetchAllVideos,
  fetchGroupVideos,
}
